import { useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useLoading } from "../../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../../constants/loadingKeys";
import { toLocalISOWithOffset } from "../../../../../utils";
import { createPatientRefusalReason } from "../../../../../app/patientSlice";
import { UN_ASSESS_WOUND_TYPE } from "../../../../../constants";

export const useUnableToAssessWound = () => {
  const dispatch = useDispatch();
  const { patientId } = useParams();
  const isLoading = useLoading(LOADING_KEYS.PATIENT_REFUSAL_REASON);
  const reasons = useSelector((s) => s.patient.detailViewData?.patientRefusalReasons);

  const selectedReasons = useMemo(() => UN_ASSESS_WOUND_TYPE.filter((item) => reasons?.includes(item.key)), [reasons]);

  const [activeChip, setActiveChip] = useState(null);
  const [notes, setNotes] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const isDisabled = !activeChip || isLoading || (activeChip === "other" && !notes);

  const handleSelect = useCallback((key) => {
    setActiveChip((prev) => (prev === key ? null : key));
  }, []);

  const handleConfirm = useCallback(() => {
    if (!activeChip) return;

    const signLockedDate = toLocalISOWithOffset(new Date());
    const payload = {
      ne1Id: patientId,
      refusalReason: activeChip,
      signedDate: signLockedDate,
      lockedDate: signLockedDate,
      notes: notes.trim(),
    };

    dispatch(createPatientRefusalReason(payload, setIsSuccess));
  }, [dispatch, patientId, activeChip, notes]);

  const handleNoteChange = (e) => {
    setNotes(e.target.value);
  };

  return {
    activeChip,
    notes,
    isSuccess,
    isLoading,
    isDisabled,
    selectedReasons,
    handleNoteChange,
    handleSelect,
    handleConfirm,
  };
};
